import { render, staticRenderFns } from "./serviceDilog.vue?vue&type=template&id=3756c3ea&scoped=true"
import script from "./serviceDilog.vue?vue&type=script&lang=js"
export * from "./serviceDilog.vue?vue&type=script&lang=js"
import style0 from "./serviceDilog.vue?vue&type=style&index=0&id=3756c3ea&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3756c3ea",
  null
  
)

export default component.exports